var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3EAF3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1761 19.9523L9.88195 16.6581C9.79581 16.571 9.69322 16.5017 9.58013 16.4545C9.46703 16.4072 9.34569 16.3829 9.22312 16.3829C9.10056 16.3829 8.97921 16.4072 8.86612 16.4545C8.75303 16.5017 8.65044 16.571 8.5643 16.6581C8.47711 16.7443 8.40788 16.8469 8.36064 16.96C8.31339 17.0731 8.28906 17.1944 8.28906 17.317C8.28906 17.4395 8.31339 17.5609 8.36064 17.674C8.40788 17.7871 8.47711 17.8896 8.5643 17.9758L12.5078 21.9193C12.8749 22.2864 13.4678 22.2864 13.8349 21.9193L23.8114 11.9523C23.8985 11.8661 23.9678 11.7635 24.015 11.6504C24.0623 11.5373 24.0866 11.416 24.0866 11.2934C24.0866 11.1709 24.0623 11.0495 24.015 10.9364C23.9678 10.8233 23.8985 10.7208 23.8114 10.6346C23.7252 10.5474 23.6226 10.4782 23.5095 10.4309C23.3964 10.3837 23.2751 10.3594 23.1525 10.3594C23.03 10.3594 22.9086 10.3837 22.7955 10.4309C22.6824 10.4782 22.5799 10.5474 22.4937 10.6346L13.1761 19.9523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.f404bc53c7f82e62b8988a5fad4b40c2.svg";
export { ForwardRef as ReactComponent };